import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
import { ScFieldsFragmentDoc, ScWithMinMaxFieldsFragmentDoc } from './share-class.graphql';
export type GqlMeetingParticipantShareFieldsFragment = { id: string, numberOfShares?: string | null, numberOfVotes?: string | null, meetingParticipantId: string, shareClass?: { name: string, voteWeight: string, quantity?: string | null } | null };

export const MeetingParticipantShareFieldsFragmentDoc = gql`
    fragment MeetingParticipantShareFields on MeetingParticipantShare {
  id
  shareClass {
    ...ScFields
  }
  numberOfShares
  numberOfVotes
  meetingParticipantId
}
    ${ScFieldsFragmentDoc}`;